import { computed, onBeforeUnmount, ref, watch } from 'vue';
const AUTO_INTERVAL = 200;
const STEP_BUCKETS = [
    [30, 0.05],
    [70, 0.03],
    [96, 0.01],
];
/** Resolve Spin `percent` / `auto` mock progress (antd ≥ 5.18). */
export default function usePercent(spinning, percent) {
    const mockPercent = ref(0);
    let mockInterval = null;
    const clear = () => {
        if (mockInterval) {
            clearInterval(mockInterval);
            mockInterval = null;
        }
    };
    watch([spinning, percent], () => {
        clear();
        if (percent.value === 'auto' && spinning.value) {
            mockPercent.value = 0;
            mockInterval = setInterval(() => {
                const prev = mockPercent.value;
                const restPTG = 100 - prev;
                for (let i = 0; i < STEP_BUCKETS.length; i += 1) {
                    const [limit, stepPtg] = STEP_BUCKETS[i];
                    if (prev <= limit) {
                        mockPercent.value = prev + restPTG * stepPtg;
                        return;
                    }
                }
            }, AUTO_INTERVAL);
        }
    }, { immediate: true });
    onBeforeUnmount(clear);
    return computed(() => (percent.value === 'auto' ? mockPercent.value : percent.value));
}
